import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  onChange?: (isChecked: boolean) => void
  isChecked: boolean
  label?: string
  'data-on'?: string
  'data-off'?: string
  description?: string
  disabled?: boolean
  isInsurance?: boolean
}

export const Switch: React.FC<Props> = (props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange && props.onChange(event.target.checked)
  }

  return (
    <label className={clsx(s.switch, props.isInsurance && s.insuranceSwitch)}>
      <input
        type="checkbox"
        role="switch"
        data-on={props['data-on']}
        checked={props.isChecked}
        data-off={props['data-off']}
        onChange={onChange}
        aria-checked={props.isChecked}
        disabled={props.disabled}
      />
    </label>
  )
}
